export const networking = {
  'QrBadge': 'QR Badge',
  'seeAll': 'Vedi tutto',
  'newcommers': 'New Networkers',
  'checkThemOut': "Dagli un'occhiata!",
  'topicsToDiscuss': 'Argomenti da discutere',
  'OneOnOneMeet': 'Incontro 1:1',
  'learnMoreNetworking': 'Scopri di più su Networking Hub',
  'scanQrCode': 'Scansiona il codice QR',
  'myBadge': 'Il mio badge',
  'message': 'Messaggio',
  'scannedBadge': 'Badge scansionato',
  'viewProfile': 'Visualizza il profilo',
  'userRatingDetails': 'Dettagli valutazione utente',
  'networkingHub': 'Networking Hub',
  'totalScore': 'Punteggio totale:',
  'scoreComposedOf': 'Questo punteggio è composto da:',
  'confirmationText': 'Sei sicuro? Questo non può essere annullato.',

  'welcomeMessage': 'Benvenuto su <strong>Networking Hub</strong>, dove le connessioni prendono vita! Ecco come funziona:',
  'connectingMadeSimpleTitle': 'Connettere è facile',
  'connectingMadeSimpleDescription':
    'Networking Hub offre attività strutturate e livelli per aiutarti a connetterti in modo efficace:',

  'newcomersDescription':
    '<strong>Newcomers:</strong> Esplora i profili dei nuovi arrivati, aggiungi quelli che ti interessano alla tua lista e invia loro messaggi. Puoi anche connetterti con loro personalmente.',
  'shortlistDescription': '<strong>Shortlist:</strong> Una volta che mostri interesse per qualcuno, viene aggiunto alla tua lista.',
  'contactedConnectedDescription':
    '<strong>Contacted/Connected:</strong> Quando contatti qualcuno e ricevi una risposta, passa in queste categorie.',
  'skipDescription': '<strong>Skip:</strong> Non sei interessato? Basta saltare il profilo e andare avanti!',

  'enhancedNetworkingActivitiesTitle': 'Attività di networking avanzate',
  'enhancedNetworkingActivitiesDescription': 'Oltre alle connessioni dirette, il Hub include:',

  'topicsToDiscussDescription':
    '<strong>Topics to Discuss:</strong> Esplora argomenti che ti interessano e connettiti con gli autori o i partecipanti. Partecipa a discussioni online o pianifica riunioni di gruppo per approfondire questi argomenti.',
  'oneOnOneMeetingPlannerDescription':
    '<strong>1:1 Meeting Planner:</strong> Gestisci le richieste di incontro, segui gli incontri pianificati e organizza facilmente il tuo programma.',

  'gamificationTitle': 'Gamification per divertimento e coinvolgimento',
  'gamificationDescription':
    'Aumenta la tua attività con una classifica che traccia i tuoi punti e mostra i networker più attivi. Ecco come puoi guadagnare punti:',

  'pointsSystem': {
    points1000ProfileComplete: '<strong>1.000 punti:</strong> Completa il tuo profilo (inclusa una foto).',
    points1000PushNotifications: '<strong>1.000 punti:</strong> Abilita le notifiche push.',
    points100SendMeetingRequest: '<strong>100 punti:</strong> Invia una richiesta di incontro 1:1.',
    points400GetAcceptedRequest: '<strong>400 punti:</strong> Fai accettare la tua richiesta di incontro 1:1.',
    points400AcceptRequest: '<strong>400 punti:</strong> Accetta una richiesta di incontro 1:1.',
    points100DeclineRequest: '<strong>100 punti:</strong> Rifiuta una richiesta di incontro 1:1.',
    points400CreateDiscussion: '<strong>400 punti:</strong> Crea un argomento di discussione.',
    points50LikeDiscussion: '<strong>50 punti:</strong> Metti mi piace a un argomento di discussione.',
    points200PostFirstComment: '<strong>200 punti:</strong> Ogni volta che pubblichi il tuo primo commento su un altro argomento.',
    points100LikeOnTopic: '<strong>100 punti:</strong> Ottieni un mi piace sul tuo argomento.',
    points200UniqueCommenter: '<strong>200 punti:</strong> Ottieni un commentatore unico sul tuo argomento.',
    points100LikeShortlistUser: '<strong>100 punti:</strong> Metti mi piace/aggiungi un utente alla tua lista.',
    points50SkipUser: '<strong>50 punti:</strong> Salta un utente.',
    points200StartChat: '<strong>200 punti:</strong> Inizia una chat (contattato).',
    points300GetChatResponse: '<strong>300 punti:</strong> Ottieni una risposta in chat (connesso).',
    points400RespondToChat: '<strong>400 punti:</strong> Rispondi a una richiesta di chat (connesso).',
    points500SpeedNetworking: '<strong>500 punti:</strong> Per ogni sessione di speed networking.'
  },

  'finalMessage':
    'Sfrutta al massimo il Networking Hub, scopri nuove opportunità e sali nella classifica mentre ti connetti e interagisci con professionisti simili!',

  'manageMeeting': 'Gestisci riunione',
  'addToCalendar': 'Aggiungi al calendario',
  'cancel': 'Annulla',
  'accept': 'Accetta',
  'accept&addToCalendar': 'Accetta e aggiungi al calendario',
  'editDetails': 'Modifica dettagli',
  'reject': 'Rifiuta',
  'delete': 'Elimina',
  'exportContact': 'Esporta contatto',
  'scheduleNewOneOnOne': 'Pianifica un nuovo 1:1',
  'initiatedBy': 'Iniziato da',
  'rejectedBy': 'Rifiutato da',
  'you': 'tu',
  'meetPassed': "L'incontro è passato",
  'meetInProgress': 'In corso',

  'myOneOnOne': 'Il mio 1:1',

  'speed': {
    history: 'Cronologia',
    minutes: 'min.',
    users_available: 'utenti',
    rules: 'Regole',
    activate: 'Attivare',
    matching: 'Abbinamento...',
    start: 'Inizia',
    find_a_user: 'Trova un utente con la stessa immagine',
    find_a_user_number: 'Trova un utente con lo stesso numero',
    waiting: 'In attesa...',
    speaking_now: 'Sta parlando ora',
    networking_topics: 'Argomenti di networking',
    session_ended: 'Sessione terminata',
    find_next_partner: 'Trova il prossimo partner',
    find_next_group: 'Trova il prossimo gruppo',
    partner_wasnt_ready: 'Il partner non era pronto',
    partner_wasnt_ready_description: 'Sembra che il partner non fosse pronto per la discussione. Troviamone uno nuovo!',
    start_matching: 'Inizia l’abbinamento'
  }
}
